import loadable from 'utils/loadable.jsx';

export default loadable(() => import('./index.jsx'), {
  fallback: null,
});
